export default __webpack_public_path__ + "static/media/hbs-blk-2.afa3a139.png";